<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-1.jpg)' }"></div>
              <img src="public/images/pages/services/banner-1.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <h5 class="title">Macetas de plastico para Cultivo</h5>

            <p>
              Procesos Plasticos pone a sus ordenes un amplio catalogo de contenedores para la industria de la horticultura y el viverismo, nuestras macetas son hechas de Polipropileno (PP) recuperado, están hechas para durar el paso de los años, son la mejor elección para la producción a gran escala en los invernaderos, viveros o para plantaciones en exteriores.
            </p>
            <p>
              Nuestras macetas de plástico aseguran a tus plantas un drenaje rápido y eficaz, además de contar con agujeros específicos para que las raíces no acaben enredadas asfixiando así el proceso.
            </p>

            <br />
            <p>
              Las macetas para cultivo de la línea Azalea© son nuestro contenedores de plástico especiales de producción.
            </p>

            <br />
            <p class="note">
              Maceta para cultivo<br />
              Manufactured by: Procesos Plasticos Inyectados S.A de C.V<br />
              Model: Maceta Azalea<br />
              Product ID: Azl<br />
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
